import * as React from 'react';

import { Box, Link, Text } from '@opendoor/bricks-next';

import { CXA_SMS_NUMBER, CXA_SMS_NUMBER_FORMATTED } from 'src/helpers/globals';

const ErrorNotice: React.FC = () => {
  return (
    <Box>
      <Text typography="$labelMedium" $largerThanSM={{ fontSize: '$labelLarge' }} tag="label">
        Think we made a mistake?
      </Text>
      <Text typography="$bodyMedium" tag="p" mt={7}>
        Text our team at{' '}
        <Link
          typography="$labelMedium"
          href={`sms:${CXA_SMS_NUMBER_FORMATTED}`}
          analyticsName="reception-fe-error-email-opendoor"
          aria-label="Text Opendoor"
        >
          {CXA_SMS_NUMBER}
        </Link>{' '}
        and we'll help figure it out.
      </Text>
    </Box>
  );
};

export default ErrorNotice;
